import axios from 'axios';

export class SubscribeForm {
	constructor() {
		const form = document.querySelector('form.subscribe_form');
		if(!form){
			return;
		}

		form.addEventListener('change', () => {
			const select = form.querySelector('.moment_dropdown select');
			this.selectMoment(select.value);
		});
	}

	selectMoment(moment) {
		const url = window.WPURLS.ajaxurl;

		axios.get(url, {
			params: {
				action: 'subscribe_trainingmoment_overview',
				moment: moment,
			}
		}).then((response) => {
			document.querySelector('.m-subscribe-details').innerHTML = response.data;
			// console.log(response.data);
		})

	}
}